/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABrUlEQVR4nOVUO0gDQRCNoGLh385PJ2hlZWdxlpG4M5PAZiaKRAWD2NmojSkELcTWys7CVrAUEbURKxEREcReEBtRBL8k7t4dfpJLvEYcmGY/772dmX2RyL8JQF5SyDcm50MFJxppAZJHIHnLpUJ5QEw3hkYAINMW3JeT4REQn+SVk5wBydXHK/goHHCQXk81zwHJglsqJT1hqF81il8QuUMp3Qkkr4Zw5VfgTjpdA8S3pjy7LinKoSG9zmQyVWUTKJKUWx5Ijtn1QUxNeesSL5sAkLftWGqtG+y61rrZjq0i3ioLPB4fblcoz3mVyBtfyIk3zSueAKS1dPXEWVuGQeKBz/uKOOH7eDOl4lcolEvbSMdxKj8f0FpX52zDEFzk7gRGR+R+Vx3xsUKe/S4B5dQ9l0j2BSYAkvVvrOGtUCritUDg0ehwPZDcl0yAcqe1rg2ifsJnDdlYbKipUPqHQSGPFifwfmneGiJFIhbTbXacFcl+YXDQXZ7PyE5RNSZyNuKOdCLV/fNBlGWvaZIOSgAk475+LBZScmB9P1DDIoYAoA6Qz82v3wt672/EO0eoKBK/wikXAAAAAElFTkSuQmCC)
 */
export const AIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M20.84 21.32a.5.5 0 0 1-.46.68h-1.52a1 1 0 0 1-.94-.66l-1.55-4.28H7.63l-1.56 4.28a1 1 0 0 1-.94.66H3.62a.5.5 0 0 1-.47-.68l7.09-18.6a1 1 0 0 1 .93-.64h1.63a1 1 0 0 1 .93.65l7.11 18.6ZM11.98 5.1l-3.43 9.43h6.87L11.98 5.1Z"
        className={colorClass}
      />
    </svg>
  );
};
